import "core-js/modules/es.array.push.js";
import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'App',
  setup() {
    const token = '2bfdcc6e7b614934972e91a7b0ce80bb';
    const selectable = (row, index) => {
      if (typeof row.username != 'undefined' && index > 0) {
        //为true则行可勾选
        return true;
      } else {
        return false;
      }
    };
    //批量删除
    const mulDel = rows => {
      console.log(rows);
    };
    //表格头部左边 添加 按钮操作
    const add = rows => {
      Object.keys(rows).forEach(key => {
        console.log(rows[key]);
      });
    };
    //行 禁用 按钮操作, row = 行数据， index = 行索引， service = 组件的服务类实例
    const lock = (row, index, service) => {
      console.log(row, index);
      service.delRow(); //调用组件中的服务类实例中方法
      console.log('service = ', service);
    };
    //行中输入框修改事件
    const changeUser = val => {
      console.log('修改后值=', val);
    };
    //表格数据加载前回调函数，作用是将 表格组件中的服务类实例暴露出来，便于操作表格数据
    const beforeLoadTable = tableService => {
      console.log('表格组件中service类实例g', tableService);
      //关联字段下拉列表数据过滤
      /*tableService.table_config.field_filter = {
        model_id: 0
      }*/
      //设置表单中组件的change事件回调函数， 例如在联动下拉框中使用
      tableService.import_config.changeEvent = (form_field_name, sel_val, linkage) => {
        console.log('form_field_name=', form_field_name);
        console.log('sel_val=', sel_val);
        console.log('linkage=', linkage);
      };
    };
    //表格字段加载完后
    const afterLoadTable = table_config => {
      console.log(table_config);
    };
    //是否显示行详情按钮, 默认true
    const detailBtnVisible = row => {
      console.log('row', row);
      return true;
    };
    //是否显示行编辑按钮，默认true
    const editBtnVisible = row => {
      console.log('row', row);
      return true;
    };
    //是否显示行删除按钮，默认true
    const delBtnVisible = row => {
      console.log('row', row);
      return true;
    };
    const fileData = ref(); //文件信息数据
    const dialogVisible = ref(false); //上传弹窗
    const fromEditor = ref(false); //是否来自编辑器上传
    //上传动作，触发打开自定义的上传弹窗
    const uploadAction = (data, field) => {
      fileData.value = data;
      dialogVisible.value = true;
      fromEditor.value = false;
      if (field == 'editor') {
        fromEditor.value = true;
      }
      console.log('值：', data);
      console.log('字段：', field);
    };
    //保存文件信息，如可将文件管理器中选择的文件信息保存
    const saveFile = () => {
      if (fromEditor.value) {
        fileData.value.url = 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/300';
      } else {
        fileData.value.push({
          field_name: 'photo_url',
          name: '200.jpg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg'
        });
        fileData.value.push({
          field_name: 'photo_url',
          name: '201.jpg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/300'
        });
      }
      dialogVisible.value = false;
    };
    return {
      token,
      selectable,
      mulDel,
      add,
      lock,
      changeUser,
      beforeLoadTable,
      afterLoadTable,
      detailBtnVisible,
      editBtnVisible,
      delBtnVisible,
      uploadAction,
      dialogVisible,
      saveFile
    };
  }
});